import { useAppSelector } from "integrations/redux/hooks"
import { useWeatherHeatmapOpacity, selectWeatherTimeline } from "features/map/control/selectors"
import { useViewport } from "features/map/GlobalViewState"
import { LightningRiskHeatmapLayer } from "./LightningRiskHeatmapLayer"
import { LIGHTNING_STRIKES_MIN_ZOOM } from "./lightningStrikesLayers"
import { createNoCoverageLayer } from "../shared/NoCoverageLayer"
import { createTileSource } from "../series/weatherTileSource"
import { useDisplayFrame, useWeatherSeries } from "../series/weatherSeries"

const source = createTileSource("lightning")

export const useLightningLayer = () => {
    const series = useWeatherSeries("lightning", source)
    const { currentTime } = useAppSelector(selectWeatherTimeline)
    const opacity = useWeatherHeatmapOpacity()
    const frame = useDisplayFrame("lightning", series, currentTime)
    const viewport = useViewport()

    const strikeDetailVisible = viewport.zoom >= LIGHTNING_STRIKES_MIN_ZOOM
    const playheadInFuture = Date.parse(currentTime) > Date.now()
    if (!series || (strikeDetailVisible && !playheadInFuture)) return { layer: null }

    if (!series.hasCoverage) {
        return { layer: createNoCoverageLayer(series.bounds, "LightningNoCoverageLayer") }
    }

    if (!frame) return { layer: null }

    return {
        layer: new LightningRiskHeatmapLayer({
            id: "LightningRiskHeatmapLayer",
            imageA: frame.imageA,
            imageB: frame.imageB,
            imageWeight: frame.imageWeight,
            bounds: frame.bounds,
            opacity,
        }),
    }
}
